import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import componentStyles from './pc-tag.css.lit';

type TagVariant = 'default' | 'outlined' | 'secondary';

/**
 * Tag component
 * @element pc-tag
 * @slot - This element has a default slot
 */
@customElement('pc-tag')
export class PCTag extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  @property()
  variant: TagVariant = 'default';

  render(): TemplateResult {
    const classes = {
      tag: true,
      [this.variant]: true,
    };

    return html`
      <div class=${classMap(classes)}>
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-tag': PCTag;
  }
}
